import { Component, OnInit, ViewChild } from '@angular/core';
import { Venue } from 'src/app/models/venue.model';
import { VenueService } from 'src/app/services/aws/venue/venue.services';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'manage-venues.component',
  templateUrl: './manage-venues.component.html',
  styleUrls: ['./manage-venues.component.scss']
})
export class ManageVenuesComponent implements OnInit {
  public showGlobalSpinner: boolean = false;
  venues: Venue[] = [];
  errorMessage: string = '';

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  breadcrumbOptions = {
    breadcrumb: [
      {
        label: 'Dashboard',
        itemclass: 'Breadcrumb-item',
        linkclass: 'Breadcrumb-link',
        link: '/admin/dashboard'
      },
      {
        label: 'Manage Venues',
        itemclass: 'Breadcrumb-item',
        linkclass: 'Breadcrumb-link',
        link: '/admin/settings/manageVenues'
      }
    ],
  };

  constructor(
    private venueService: VenueService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.loadVenues();
  }

  loadVenues(): void {
    this.showGlobalSpinner = true;
    this.venueService.getVenues().subscribe({
      next: (response) => {
        if (!response?.venus[0]?.isComplete) {
          this.snackBar.open('Some of the Venue list are not properly loaded, please try again later.', 'OK', {
            duration: 8000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ['error-snackbar']
          });
        }
        this.showGlobalSpinner = false;
        this.venues = response?.venus?.sort((a, b) => a.venueName?.localeCompare(b.venueName));
      },
      error: (error) => {
        this.showGlobalSpinner = false;
        this.errorMessage = 'Failed to load venues. Please try again later.';
      }
    });
  }
}